import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import App from "./App";
import ThemeContextProvider, { useTheme } from "./context/useThemeContext";
import { DarkTheme } from "./style/theme";
import EditorContextProvider from "./context/useEditorContext";
import { SupabaseProvider } from "./context/useSupabaseContext";
import { ToastContainer, Zoom, toast } from "react-toastify";
import { FaInfoCircle } from "react-icons/fa";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    // <React.StrictMode>
    <ThemeContextProvider defaultTheme={DarkTheme}>
        <SupabaseProvider>
            <EditorContextProvider>
                <App />
                <CustomToastContainer />
            </EditorContextProvider>
        </SupabaseProvider>
    </ThemeContextProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

function CustomToastContainer() {
    const { theme } = useTheme();

    return (
        <ToastContainer
            position="top-right"
            autoClose={2500}
            hideProgressBar
            newestOnTop={false}
            // closeOnClick
            rtl={false}
            // pauseOnFocusLoss
            
            draggable
            pauseOnHover
            theme="dark"
            transition={Zoom}
            toastStyle={{
                backgroundColor: theme.mainContentColor,
                border: "1px solid " + theme.headerColor,
                fontSize: "14px",
                color: theme.fontColor[50],
            }}
            // icon={({ type, theme: theme_ }) => {
            //     if (type === "info") {
            //         return <FaInfoCircle size={20} color={theme.accentColor} />;
            //     }
            // }}
        />
    );
}
